module.exports = __webpack_public_path__ + "img/move-white.2b508668.svg";